import 'mutationobserver-shim'
import { clamp } from 'src/helpers/MathUtils'
import EventEmitter from 'src/helpers/EventEmitter'

const Events = {
  RESIZE: 'resize',
}

let defaultConfig = {
  scale: 1,
  baseFontSize: 100,
  breakpoints: [],
}

class ResizeService {
  constructor(config) {
    Object.assign(this, EventEmitter)

    this.config = Object.assign(defaultConfig, config)
    this.orientation = 'portrait'
    //this.device = this.deviceType()
    this.html = document.querySelector('html')
    this.timers = [null, null, null]

    this.alwaysTrigger = false // always trigger resize event even if dimensions haven't changed
    this.onlyWidth = false // only monitor width changes

    this._onResize()
    this._monitorHTMLStyles()

    //window.addEventListener('orientationchange', this._update, false)
    window.addEventListener('orientationchange', this._onResize)
    window.addEventListener('resize', this._onResize)
  }

  destroy() {
    window.removeEventListener('resize', this._onResize)
  }

  setBaseFontSize = (val) => {
    this.config.baseFontSize = val
    this._onResize()
  }

  _monitorHTMLStyles = () => {
    this.htmlFontStyle = this.html.style.fontSize

    this.htmlObserver = new MutationObserver((mutations) => {
      for (let mutation of mutations) {
        if (mutation.attributeName === 'style') {
          let htmlFontStyle = this.html.style.fontSize

          if (this.htmlFontStyle !== htmlFontStyle) {
            if (htmlFontStyle === '') this._updateFontSize()
            this.htmlFontStyle = htmlFontStyle
          }
        }
      }
    })

    this.htmlObserver.observe(this.html, { attributes: true })
  }

  _onResize = () => {
    this._resize()
  }

  _resize = () => {
    let wW = window.innerWidth
    let wH = window.innerHeight
    console.log('window.inner!!!', wW, wH)
    // only continue if things changed
    //console.log(window.innerWidth, window.innerHeight, this.orientation,  `before${id}!!!!!!!!!!!!!!!!!!!!!!!!!!!!!`)
    if (wW === this.width && (wH === this.height || this.onlyWidth)) {
      if (this.alwaysTrigger) {
        this.emit(Events.RESIZE, {
          width: this.width,
          height: this.height,
          device: this.device,
          orientation: this.orientation,
        })
      }
      return
    }

    this.width = wW
    this.height = wH
    //this.device = this.deviceType()

    //this._setScreenOrientationClass()
    this._updateFontSize()
    //this._setScaleClass()

    this.emit(Events.RESIZE, {
      width: this.width,
      height: this.height,
      device: this.device,
      orientation: this.orientation,
    })
    //console.log(window.innerWidth, window.innerHeight, this.orientation,  'after!!!!!!!!!!!!!!!!!!!!!!!!!!!!!')
  }

  _updateFontSize = () => {
    let maxh = 75 + 128 + 144 + 60 + 120 * 4 + 40 * 4 + 98 + 174 + 100 + 200
    let sw = window.innerWidth / 750
    let sh = window.innerHeight / maxh
    console.log('maxh', maxh, sw, sh)
    this.scale = sh
    this.scale = Math.min(sw, sh)
    let w = window.innerWidth / sh
    console.log(777, w)
    if (sh < sw) this.safePadding = (w - 750) / 2
    else this.safePadding = 0
    this.fontSize = this.config.baseFontSize * this.scale
    this.html.style.fontSize = `${this.fontSize}px`
    //console.log(scale, this.scale, this.orientation, window.innerHeight, window.innerWidth, this.fontSize)
  }
}

let service = new ResizeService()
service.Events = Events
window.ResizeService = service
export default service
